import React from "react";
import "../grid/Grid.css";

export default function InvisibleTile() {
  return <div className="tile" />;
}
